import React, {useRef, useState} from 'react';
import Form from "../../../components/form/Form";

const roundHourlyRate = (rate) => {
    return Math.round((rate + Number.EPSILON) * 100) / 100
}
const TalentRateEditTab = ({
                                     opportunity,
                                     editable = true,
                                     onUpdate = async () => true,
                                     disabled,
                                 }) => {
    const mapping = (model = {}) => {
        return model;
    }

    const formRef = useRef(null);
    const fieldProps = ['hourly_rate']

    const buildModel = (fromModel = opportunity?.job_candidate) => {
        let model = TB.pick(fromModel, fieldProps);

        return mapping(model)
    }
    const [formModel, setFormModel] = useState(buildModel());

    const availRateFields = () => {

        // let profileDiscipline = opportunity.profileDisciplineForTalent(auth);

        return [
            {
                fields: {
                    rateHeader: (
                        <div className="lg:flex flex-row items-center my-2 gap-6">
                            <h3 className="proposal-tab-header mr-2 mb-0 mt-0 whitespace-nowrap">
                                Bill Rate
                            </h3>
                            <p className="proposal-tab-subheader mb-0 mt-0">
                                A market competitive rate within the client’s budget will maximize chances of
                                securing the project
                            </p>
                        </div>
                    )
                }
            },
            {
                className: 'hourly-rate-container field-section',
                fields: [
                    {
                        className: 'hourly-rate-fields field-section',
                        fields: {
                            hourly_rate_label: {
                                component: (
                                    <label className="rate-label col-form-label" htmlFor="hourly_rate">
                                        Proposed Rate for this role
                                    </label>
                                ),
                                columns: 3,
                                style: styles.rowField,
                            },
                            hourly_rate: {
                                label: false,
                                type: 'number',
                                addonBefore: "$",
                                required: true,
                                columns: 4,
                                disabled: disabled,
                                style: styles.rowField,
                                addonAfter: (
                                    <span className="rate-note text-bold">
                                        per hour
                                    </span>
                                )
                            },

                            avg_rate_note: {
                                style: styles.field,
                                columns: 5,
                                component: opportunity.hasClientTargetRate() ? (
                                    <div className="proposal-rate-note">
                                        <i className="fa fa-info-circle"/>
                                        <p>
                                            The client has set a budget bill rate for this project:&nbsp;&nbsp;
                                            <b>{TB.formatCurrency(opportunity.project_position?.targetRate())} per hour</b>
                                        </p>
                                    </div>
                                ) : (
                                    <div className="proposal-rate-note">
                                        <i className="fa fa-info-circle"/>
                                        <p>
                                            The average rate on Wripple with similar roles and <b>6-10 years
                                            experience</b>:&nbsp;&nbsp;
                                            <b>{TB.formatCurrency(opportunity.project_position?.marketRate())} per
                                                hour</b>
                                        </p>
                                    </div>
                                )
                            },
                        }
                    },
                    {
                        className: 'profile-hourly-rate field-section',
                        fields: {
                            hourly_rate_difference: {
                                columns: 12,
                                style: {...styles.rowField, padding: 0},
                                component: (
                                    opportunity.differenceFromRequestedHourlyRate() > 0 ? (
                                        <div className="profile-rate-note difference-warning">
                                            <p>*</p>
                                            <p>
                                                {opportunity.user?.fullName()} bill rate is <strong>${opportunity.differenceFromRequestedHourlyRate()} per hour</strong>
                                                &nbsp;above the&nbsp;
                                                {!opportunity.hasClientTargetRate() ?
                                                    'Average Bill Rate for this role on Wripple' :
                                                    'Client Target Bill Rate for this role'
                                                }
                                            </p>
                                        </div>
                                    ) : <div/>
                                ),
                            }
                        }
                    },
                    {
                        className: 'profile-hourly-rate field-section',
                        fields: {
                            spacer: (
                                <div>
                                    <hr className="my-2"/>
                                </div>
                            ),
                        }
                    },
                    {
                        className: 'hourly-rate-fields field-section',
                        fields: {
                            hourly_rate_label: {
                                component: (
                                    <label className="rate-label col-form-label" htmlFor="hourly_rate">
                                        Proposed Payout
                                    </label>
                                ),
                                columns: 3,
                                style: styles.rowField,
                            },
                            payout_info: {
                                columns: 9,
                                style: styles.rowField,
                                component: (
                                    <span className="payout">
                                        <span>
                                            {TB.isDefined(opportunity.job_candidate?.exact_premarkup_cost) && TB.formatCurrency(opportunity.job_candidate?.exact_premarkup_cost, false)}
                                        </span>
                                        <span className="payout-info">
                                            <strong>
                                                {`$ ${roundHourlyRate(parseFloat(opportunity.job_candidate?.hourly_rate))}`}
                                            </strong>
                                            {` per hr @ `}
                                            <strong>
                                                {`${parseInt(opportunity.job_candidate?.total_hours)} total hours`}
                                            </strong>
                                        </span>
                                    </span>
                                )
                            }
                        }
                    }
                ]
            },

        ];
    }


    const hasFormModelChanged = () => {
        let opp = buildModel();
        let model = buildModel(formModel);
        return !TB.isEqual(opp, model)
    }

    const resetForm = async () => {
        let model = buildModel()

        model = mapping(model);
        await formRef.current.forceReset(model);
        await formRef.current.formRef.current.formsyForm.setFormPristine(true);
        return setFormModel(model)
    }

    const submitForm = async () => {
        let invalid = formRef.current.forceValidate(formModel);
        if (invalid) {
            console.log('invalid', invalid)
            return;
        }
        let success = await onUpdate({job_candidate: {...formModel, talent_proposed_at: new Date()}})

        if (success) {
            await resetForm();
        }

    }
    return (
        <React.Fragment>
            <div className="opp-talent-proposal-form">
                <Form
                    ref={formRef}
                    background={"transparent"}
                    mapping={mapping}
                    onSubmit={submitForm}
                    submitButton={false}
                    isDisabled={disabled}
                    model={formModel}
                    fields={availRateFields()}
                    className={
                        TB.mapClass({
                            'no-edit': !editable
                        })
                    }
                    onChange={model => {
                        setFormModel(mapping({
                                ...formModel, ...model
                            }
                        ))
                    }}>
                    {editable && (
                        <div className="mt-3 flex flex-row justify-end">
                            <button type="submit" className="btn btn-primary mr-3"
                                    disabled={disabled || !hasFormModelChanged()}>
                                Save
                            </button>
                            <button className="btn btn-outline-dark"
                                    type="button" onClick={resetForm}
                                    disabled={disabled || !hasFormModelChanged()}>
                                Cancel
                            </button>
                        </div>
                    )}
                </Form>

            </div>

        </React.Fragment>
    );
};

const styles = {
    fieldSectionCol: {
        flexDirection: 'column',
        alignItems: 'stretch'
    },
    fieldSection: {
        margin: '0 -15px',
        flexDirection: 'row'
    },
    field: {
        padding: 0,
    },
    rowField: {padding: '0 15px', marginBottom: 0}
};


export default TalentRateEditTab;